/* eslint-disable */
// import Api from '~/modules/Api';
import Emitter from 'tiny-emitter';
import { CHAT_SOCKET_EVENTS } from './constants/index';

// const SOCKET_TEST_HOST = 'wss://echo.websocket.org';
const SOCKET_TEST_HOST = 'wss://dev7.dmktz.com/cable';
const CHANNEL = 'ConversationChannel';

function intToByteArray(value) {
  // we want to represent the input as a 8-bytes array
  const byteArray = [0, 0, 0, 0];

  for (let index = 0; index < byteArray.length; index++) {
    const byte = value & 0xff;
    byteArray[index] = byte;
    value = (value - byte) / 256;
  }

  return byteArray;
}

function encodeData(timestamp, energy_spent, scores) {
  const buf = new Uint8Array(7 + scores.length);
  const ts = intToByteArray(timestamp);

  buf[0] = 0x01;
  buf[1] = ts[3];
  buf[2] = ts[2];
  buf[3] = ts[1];
  buf[4] = ts[0];
  buf[5] = energy_spent * 10;
  buf[6] = scores.length / 2;
  for (let i = 0; i < scores.length; i++) {
    buf[7 + i] = scores[i];
  }
  return buf;
}

async function calcChecksum(data, offset, report_key) {
  data[7 + offset] = data[7 + offset] ^ report_key.charCodeAt(offset);
  return sha1(report_key + btoa(String.fromCharCode.apply(null, data)));
}

async function sha1(str) {
  const buffer = new TextEncoder('utf-8').encode(str);
  const hash = await crypto.subtle.digest('SHA-1', buffer);
  const hexCodes = [];
  const view = new DataView(hash);
  for (let i = 0; i < view.byteLength; i += 1) {
    const byte = view
      .getUint8(i)
      .toString(16)
      .padStart(2, '0');
    hexCodes.push(byte);
  }
  return hexCodes.join('');
}

function safeParseJSON(jsonString, defaultValue = null) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Error parsing JSON:', error);
    return defaultValue;
  }
}
function* generateFakeData() {
  yield '';
  yield {
    from: 'ai',
    type: 'text',
    data: 'Have you checked the latest Beachwear Capsule from Dior?you would like it!;',
  };
  yield {
    from: 'ai',
    type: 'image',
    data: [
      {
        url: 'https://i.ibb.co/JxtVBWz/8622329f1fed75ba404bb2cb960ed205.png',
        name: 'img1',
      },
      {
        url:
          'https://i.ibb.co/hX0mTwK/9a92bd7d981864442ec1af6f92d05703-Expires-1719792000-Key-Pair-Id-APKAQ4-GOSFWCVNEHN3-O4-Signature-qjp.png',
        name: 'img2',
      },
      {
        url: 'https://i.ibb.co/JxtVBWz/8622329f1fed75ba404bb2cb960ed205.png',
        name: 'img3',
      },
    ],
  };
}

export class ChatWebSocket {
  #emitter = null;

  /**
   * @type {WebSocket}
   */
  socket = null;

  constructor(params = {}) {
    const { jwtToken } = params;

    this.#emitter = new Emitter();

    // const url = `${SOCKET_TEST_HOST}`;
    const url = `${SOCKET_TEST_HOST}?jid=${jwtToken}`;
    this.connect(url);

    this.socket = new WebSocket(url);
    console.log('sockettt', this.socket);

    this.initEventListeners();
  }

  on(event, callback, context) {
    return this.#emitter.on(event, callback, context);
  }

  off(event, callback, context) {
    return this.#emitter.off(event, callback, context);
  }

  once(event, callback, context) {
    return this.#emitter.once(event, callback, context);
  }

  emit(event, callback, context) {
    return this.#emitter.emit(event, callback, context);
  }

  connect(url) {
    this.socket = new WebSocket(url);
  }

  initEventListeners() {
    this.socket.onopen = event => {
      console.log('opened!!!');

      const msgSub = {
        command: 'subscribe',
        identifier: JSON.stringify({ channel: CHANNEL }),
      };
      this.send(JSON.stringify(msgSub));

      this.#emitter.emit(CHAT_SOCKET_EVENTS.connect, event);
    };

    this.socket.onmessage = event => {
      if (event && JSON.parse(event.data).identifier === JSON.stringify({ channel: CHANNEL })) {
        this.#emitter.emit(CHAT_SOCKET_EVENTS.message, event);
      }
    };

    this.socket.onclose = event => {
      this.#emitter.emit(CHAT_SOCKET_EVENTS.close, event);
    };

    this.socket.onerror = event => {
      this.#emitter.emit(CHAT_SOCKET_EVENTS.error, event);
    };
  }

  send(message) {
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      throw new Error('cannot call send() while not connected');
    }

    console.log('in send message', message);
    this.socket.send(message);
  }

  // connect(url) {
  //   if (this.connected && this.socket && challengeID === this.challengeID) {
  //     return Promise.resolve(this.socket);
  //   }

  //   this.challengeID = challengeID;
  //   this.wearableID = wearableID;
  //   if (this.hasCredentialExpired('reportKey')) {
  //     const data = await Api.getReportKey();
  //     this.setCredential('reportKey', data.report_key, data.expires_in);
  //   }
  //   if (this.hasCredentialExpired('jwt')) {
  //     const data = await Api.getJWT();
  //     this.setCredential('jwt', data.jwt_token, data.expires_in);
  //   }
  //   const url = `wss://${Api.base}/cable?jid=${this.jwt()}`;

  //   return new Promise(resolve => {
  //     this.socket = new WebSocket(url);
  //     this.socket.onopen = event => {
  //       this.connected = true;
  //       const msg = {
  //         command: 'subscribe',
  //         identifier: JSON.stringify({
  //           channel: 'ReportMotionChannel',
  //         }),
  //       };
  //       this.socket.send(JSON.stringify(msg));
  //       resolve(this.socket);
  //     };
  //   });
  // }
}

// const ChatWebSocket = {
//   socket: null,
//   connected: false,
//   challengeID: '',
//   wearableID: '',
//   credential: {
//     reportKey: {},
//     jwt: {},
//   },
//   async connect(challengeID, wearableID) {
//     if (this.connected && this.socket && challengeID === this.challengeID) {
//       return Promise.resolve(this.socket);
//     }

//     this.challengeID = challengeID;
//     this.wearableID = wearableID;
//     // if (this.hasCredentialExpired('reportKey')) {
//     //   const data = await Api.getReportKey();
//     //   this.setCredential('reportKey', data.report_key, data.expires_in);
//     // }
//     // if (this.hasCredentialExpired('jwt')) {
//     //   const data = await Api.getJWT();
//     //   this.setCredential('jwt', data.jwt_token, data.expires_in);
//     // }
//     // const url = `wss://${Api.base}/cable?jid=${this.jwt()}`;
//     const url = SOCKET_TEST_HOST;

//     return new Promise(resolve => {
//       this.socket = new WebSocket(url);
//       this.socket.onopen = event => {
//         this.connected = true;
//         // const msg = {
//         //   command: 'subscribe',
//         //   identifier: JSON.stringify({
//         //     channel: 'ReportMotionChannel',
//         //   }),
//         // };
//         // this.socket.send(JSON.stringify(msg));
//         resolve(this.socket);
//       };
//     });
//   },
//   async send(payload) {
//     // report motion scores
//     const { scores, energySpent } = payload;
//     const timestamp = parseInt(new Date().getTime() / 1000, 10);
//     const buf = encodeData(timestamp, energySpent, Array.isArray(scores) ? scores : [scores]);
//     const b64buf = btoa(String.fromCharCode.apply(null, buf));
//     const checksum = await calcChecksum(buf, timestamp % (scores.length / 2), this.reportKey());
//     const msg = {
//       command: 'message',
//       identifier: JSON.stringify({ channel: 'ReportMotionChannel' }),
//       data: JSON.stringify({
//         action: 'report',
//         cid: this.challengeID,
//         wb: this.wearableID,
//         dt: b64buf,
//         ck: checksum,
//       }),
//     };
//     this.socket.send(JSON.stringify(msg));
//   },
//   disconnect() {
//     this.connected = false;
//     this.challengeID = '';
//     this.wearableID = '';
//     if (!this.socket) {
//       return;
//     }

//     this.socket.close();
//     this.socket = null;
//   },
//   jwt() {
//     return this.credential.jwt?.value || '';
//   },
//   reportKey() {
//     return this.credential.reportKey?.value || '';
//   },
//   hasCredentialExpired(name) {
//     const { value, fetchTime = 0, expiresIn = 0 } = this.credential[name] || {};
//     const expired = Date.now() / 1000 > fetchTime + expiresIn;
//     return !value || expired;
//   },
//   setCredential(name, value, expiresIn) {
//     const newValue = {
//       value,
//       expiresIn,
//       fetchTime: Math.round(Date.now() / 1000),
//     };
//     this.credential[name] = newValue;
//   },
// };
